import { Component, Input, OnChanges, OnInit, SimpleChange, SimpleChanges, Sanitizer, SecurityContext } from '@angular/core';
import { Message } from '../../../models/types';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-message-details-component',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './message-details-component.component.html',
  styleUrl: './message-details-component.component.scss'
})
export class MessageDetailsComponentComponent {
  @Input() message: Message | undefined;

  constructor(private sanitizer: DomSanitizer) {}
  getSanitizedHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
}
}
